import { Components, Theme } from '@mui/material/styles';

export const toggleButtonGroupConfigs: Components<Theme>['MuiToggleButtonGroup'] =
  {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.palette.neutral['min'],

        '.MuiToggleButton-root': {
          textTransform: 'none',
          fontSize: theme.typography.body2Bold.fontSize,
          fontWeight: theme.typography.body2Bold.fontWeight,
          transition: theme.transitions.create(['background-color', 'color']),

          ':hover': {
            backgroundColor: 'transparent',
          },

          '&.Mui-selected': {
            outline: `1px solid ${theme.palette.primaries['400']}`,
            backgroundColor: theme.palette.primaries['100'],
          },
        },
      }),
    },
  };
